import useHitarea from '@packages/systems/ui/hooks/useHitarea';
import {type InputProps} from './Input.types';

export function useInput(props: InputProps) {
  const {
    disabled = false,
    invalid,
    type = 'text',
    gridColumn,
    gridRow,
    onBlur,
    onFocus,
    onKeyDown,
    onKeyUp,
    onMouseEnter,
    onMouseLeave,
    warning,
    ...rest
  } = props;

  const [interactionState, handlers] = useHitarea({
    onBlur,
    onFocus,
    onKeyDown,
    onKeyUp,
    onMouseEnter,
    onMouseLeave,
  } as any);

  const handleOnKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    handlers.onKeyDown && handlers.onKeyDown(event);
  };

  const handleOnKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
    handlers.onKeyUp && handlers.onKeyUp(event);
  };

  const wrapperProps = {
    ...interactionState,
    disabled,
    invalid,
    style: {gridColumn, gridRow},
    warning,
  } as const;

  return {
    ...handlers,
    ...rest,
    disabled,
    onKeyDown: handleOnKeyDown,
    onKeyUp: handleOnKeyUp,
    type,
    wrapperProps,
  };
}
